import React from 'react';
import styles from './Invisible.module.css';

const InvisibleButton = ({ onClick, type, disabled, text, children, className }) => {
  // Combine the default invisible button style with any additional classes passed in
  const buttonClassName = className 
    ? `${styles.invisibleButton} ${className}` 
    : styles.invisibleButton;
    
  return (
    <button
      className={buttonClassName}
      onClick={onClick}
      type={type || 'button'}
      disabled={disabled}
    >
      {children || text}
    </button>
  );
};

export default InvisibleButton;